import { httpsCallable } from 'firebase/functions';
import { v4 as uuidv4 } from 'uuid';
import { getPrefs } from 'src/components/cookie/cookie-consent';
import { functions } from 'src/libs/firebase';

const PIXEL_ID = '1415049147467722';
const PRODUCTION_PROJECT_ID = 'ctmass-8f048';
const isProduction = process.env.REACT_APP_FIREBASE_projectId === PRODUCTION_PROJECT_ID;

const sendMetaEventFn = httpsCallable(functions, 'sendMetaEvent', { timeout: 15000 });

let initialized = false;
let currentUser = null;
let lastPagePath = null;

const isAllowed = () => isProduction && getPrefs()?.marketing !== false;

const initMetaPixel = () => {
    if (initialized) return;
    initialized = true;
    (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', PIXEL_ID);
};

const readCookie = (name) => {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : '';
};

const readFbc = () => {
    const cookie = readCookie('_fbc');
    if (cookie) return cookie;
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    return fbclid ? `fb.1.${Date.now()}.${fbclid}` : '';
};

const toMatchData = (user) => (user ? {
    email: user.email || '',
    phone: user.phone || '',
    name: user.name || ''
} : null);

export const setMetaUser = (user) => {
    currentUser = user || null;
};

export const clearMetaUser = () => {
    currentUser = null;
};

export const trackMetaEvent = (eventName, customData = {}, user = currentUser) => {
    if (!isAllowed()) return;
    try {
        initMetaPixel();
        const eventId = uuidv4();
        window.fbq('track', eventName, customData, { eventID: eventId });
        sendMetaEventFn({
            eventName,
            eventId,
            eventSourceUrl: window.location.origin + window.location.pathname,
            customData,
            user: toMatchData(user),
            fbp: readCookie('_fbp'),
            fbc: readFbc()
        }).catch((error) => console.warn('[meta] server event failed', error));
    } catch (error) {
        console.warn('[meta] tracking failed', error);
    }
};

export const trackMetaPageView = (path) => {
    if (path === lastPagePath) return;
    lastPagePath = path;
    trackMetaEvent('PageView');
};
